const getDefaultState = () => {
    return {
        Salutation_LK : [],
        FundList:[],
        Race_LK : [],
        Gender_LK : [],
        Nationality_LK : [],
        HolderStatus_LK : [],
        State_LK : [],
        MaritalStatus_LK: [],
        InternationalDialingCode_LK:[],
        InvestmentPurpose_LK:[],
        SourceOfWealth_LK:[],
        Country_LK : [],
        EmploymentStatus_LK : [],
        NatureofBusiness_LK : [],
        TaxResidency_LK : [],
        UnavailableTINReason_LK : [],
        USResident_LK : [],
        USResidentIndicia_LK : [],
        IdType_LK : [],
        TypeOfUSIndicia_LK : [],
        Agents_LK:[],
        Agents_LK2:[],
        Agent_Options: [],
        EMISStatusCode_LK: [],
        EPFAccountType :[],
        EmisPostCode :[
            {
                label:"No Options",
                value:"None",
            }
        ],
        EmisPostCodeTemp:[
            {
                label:"No Options",
                value:"None",
            }
        ],
        EmisPostCodeFiltered:[],
        Form:{
            Bank:[],
            BankCurrency : [],
            PRSWithdrawalReason:[],
            PaymentMethod:[],
            ForeignPaymentMethod:[],
            IdType:[]
        },
      //  Agents_LK : [
           // {value:'RD20074', label:'CHIA JENNA'},
         //   {value:'RD20160', label:'KHOR XIANG PING'}
      //  ],
        Schemes_LK : [],
        Schemes_LK_2:[]
    }
}

const state = getDefaultState()

const getters = {

}

const actions = {
    
}


const mutations = {
    
    UpdatePostCodeList: (state, value) => state.EmisPostCode = value,
    
    UpdateFundList: (state, value) => state.Schemes_LK = value,

    ResetLookup (state) {
        Object.assign(state, getDefaultState())
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}